import styled, { css } from "styled-components"

export const CheckboxContainer = styled.div``

export const CheckboxLabel = styled.label`
  display: inline-flex;
  cursor: pointer;
`

export const CheckMarkIconWrap = styled.div<{ sizeType?: string }>`
  display: block;
  position: relative;
  line-height: 0;
  min-width: 16px;
  min-height: 16px;
  width: 16px;
  height: 16px;
  margin-right: 0.5em;

  ${(p) =>
    p.sizeType === "large" &&
    css`
      min-width: 26px;
      min-height: 26px;
      width: 26px;
      height: 26px;
    `}

  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 3px;
    transition: all 150ms;
    border: 1px solid;
    border-color: var(--light-gray);
    background-color: var(--white);
    z-index: 1;
  }
`
export const CheckboxLabelText = styled.span`
  line-height: 1.5;
`

export const CheckboxInput = styled.input<{
  priority?: boolean
  sizeType?: string
}>`
  appearance: none;
  cursor: pointer;
  -webkit-appearance: none;
  display: flex;
  align-content: center;
  justify-content: center;
  transition: all 150ms;

  border: 1px solid;
  border-radius: 3px;
  border-color: var(--light-gray);

  background-color: var(--white);
  z-index: 1;

  min-width: 16px;
  min-height: 16px;
  width: 16px;
  height: 16px;
  margin-right: 0.5em;

  ${(p) =>
    p.sizeType === "large" &&
    css`
      min-width: 26px;
      min-height: 26px;
      width: 26px;
      height: 26px;
    `}

  :not(:checked) {
    &::before {
      background-color: ${(p) => p.priority && "var(--very-light-gray)"};
    }
  }

  ::before {
    content: "";
    line-height: 0;
    width: 90%;
    height: 90%;
    margin: ${(p) => p.priority && "0 20px"};
    clip-path: polygon(
      88.64% 26.34%,
      95.13% 32.72%,
      35.51% 93.3%,
      4.5% 60.25%,
      11.08% 54.07%,
      35.62% 80.23%
    );
    transform: scale(0);
    background-color: green;
  }

  :checked {
    border-color: transparent;
    background-color: var(--light-yellow);
    ::before {
      opacity: 1;
      transform: scale(1);
      border-color: transparent;
      background-color: black;
    }
  }
`
